export default {
  dbi_metrics_creditability_title: 'Metrics Creditability',
  dbi_creditability_header: 'Creditability',
  dbi_creditability_info: 'Credibility Credentials',
}